// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-type-stamp h2[data-v-f6dd54bc]{font-size:18px;font-weight:700;margin:0}.region-type-stamp p[data-v-f6dd54bc]{align-items:flex-start;color:#666e75;display:flex;font-size:14px;line-height:1.5em;margin:.5em 0 0}.region-type-stamp img[data-v-f6dd54bc]{margin:.25em .75em 0 0}.region-type-stamp.small h2[data-v-f6dd54bc]{font-size:16px}.region-type-stamp.small p[data-v-f6dd54bc]{font-size:13px;margin:.25em 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
